import 'babel-polyfill';
import 'formdata-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { compose, applyMiddleware, createStore } from 'redux';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import * as axios from 'axios';
import _ from 'lodash';

import reducer from './reducers/index.js';
import * as AppActions from './data/app/AppActions.js';
import * as EmployeeActions from './data/employee/EmployeeActions.js';
import App from './App.js';
import './flags/flags.css';
import './index.css';
import i18next from './locales';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
let store = createStore(reducer, composeEnhancers(applyMiddleware(thunkMiddleware)));

// set base url for API calls
if (process.env.REACT_APP_ENVIRONMENT === 'production')
  axios.defaults.baseURL = 'https://www.mytime.com';
else if (process.env.REACT_APP_ENVIRONMENT === 'staging-1')
  axios.defaults.baseURL = 'https://staging-1.mytime.com';
else if (process.env.REACT_APP_ENVIRONMENT === 'staging-2')
  axios.defaults.baseURL = 'https://staging-2.mytime.com';
else if (process.env.REACT_APP_ENVIRONMENT === 'sandbox')
  axios.defaults.baseURL = 'https://sandbox.mytime.com';
else if (process.env.REACT_APP_ENVIRONMENT === 'scenthound')
  axios.defaults.baseURL = 'https://scenthound.mytime.com';
else if (process.env.REACT_APP_ENVIRONMENT === 'dogstop')
  axios.defaults.baseURL = 'https://dogstop.mytime.com';
else if (process.env.REACT_APP_ENVIRONMENT === 'bowie')
  axios.defaults.baseURL = 'https://bowie.mytime.com';
else if (process.env.REACT_APP_ENVIRONMENT === 'laybare')
  axios.defaults.baseURL = 'https://laybare.mytime.com';
else if (process.env.REACT_APP_ENVIRONMENT === 'floyds')
  axios.defaults.baseURL = 'https://floyds.mytime.com';
else if (process.env.REACT_APP_ENVIRONMENT === 'beta-ro')
  axios.defaults.baseURL = 'https://beta-ro.mytime.com';
else if (process.env.REACT_APP_ENVIRONMENT === 'beta')
  axios.defaults.baseURL = 'https://beta.mytime.com';
else if (process.env.REACT_APP_ENVIRONMENT === 'local')
  axios.defaults.baseURL = 'http://localhost:5050';
else if (process.env.REACT_APP_ENVIRONMENT === 'localhost')
  axios.defaults.baseURL = 'http://localhost:3000';

// set the message that will be dispatched to reducers for ajax errors
axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (error.response !== undefined && error.response.status === 401) {
      store.dispatch({ type: 'UNAUTHORIZED' });
    } else {
      store.dispatch(
        AppActions.setError(
          _.get(error, 'response.request.responseURL'),
          _.get(error, 'response.status'),
          error.message
        )
      );
    }

    return Promise.reject(error);
  }
);

// check for access token and location in local storage
const authToken = localStorage.getItem('authToken');

if (authToken) {
  axios.defaults.params = {};
  axios.defaults.params['auth_token'] = authToken;

  store.dispatch(AppActions.setAuthToken(authToken));
  store.dispatch(AppActions.getBusinessInfo());

  const location = localStorage.getItem('location');
  const printerMac = localStorage.getItem('printerMac');

  if (printerMac) {
    store.dispatch(AppActions.setPrinterMac(JSON.parse(printerMac)));
  }

  if (location) {
    const parsedLocation = JSON.parse(location)
    store.dispatch(AppActions.getDurations(parsedLocation));
    store.dispatch(AppActions.setLocation(parsedLocation));
    store.dispatch(EmployeeActions.getEmployees(parsedLocation.id));
  } else {
    store.dispatch(AppActions.getLocations());
  }
}

i18next.on('initialized', d => {
  ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter>
        <App i18next={i18next} />
      </BrowserRouter>
    </Provider>,
    document.getElementById('root')
  );
});
